export default __webpack_public_path__ + "8f71aa546870d0f5406a85fa6d346995.png";